import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { TeacherAnalysisAPIServiceV2 } from '@protos/analysis_management/analysis.teacher.apis_connect';
import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';

export const TeacherAnalysisAPIServiceV2Client = createPromiseClient(
  TeacherAnalysisAPIServiceV2,
  lmsTransport
);

export const useTeacherAnalysisAPIServiceV2ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    TeacherAnalysisAPIServiceV2,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );

//TeacherAnalysisAPIServiceV2
